import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Goal, Stethoscope, Phone} from 'lucide-react';
import axiosInstance from "../utils/axiosInstance";
import axios from 'axios';
import './home.css';

function Home() {
  const [sections, setSections] = useState([]);
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_ENV;
  useEffect(() => {
    axiosInstance.get(`${API_URL}/homepage-sections`)
      .then(res => setSections(res.data))
      .catch(err => console.error(err));
  }, []);

  const toAbout = () => navigate('/about');
  const toContact = () => navigate('/contact');
  const toDonate = () => navigate('/donate');

  return (
    <div className='home-img'>
      <div className='home-container'>
        <h1>
          Welcome To <span className="highlight">FAAMS</span>
        </h1>
      </div>
      <div className='cards'>
        {sections.map((section, index) => (
          <div className='card' key={section.id}>
            <div className='card-content'>
              {index === 0 && <Goal color={"#00f5d4"} size={36}/>}
              {index === 1 && <Stethoscope color={"#00f5d4"} size={36}/>}
              {index === 2 && <Phone color={"#00f5d4"} size={36}/>}
              <h2>{section.header}</h2>
              <p>{section.paragraph}</p>
            </div>
            <div className='card-buttons'>
              {index === 0 && <button className='btn light' onClick={toDonate}>Donate</button>}
              {index === 1 && <button className='btn mid' onClick={toAbout}>Learn More</button>}
              {index === 2 && <button className='btn light' onClick={toContact}>Contact Us</button>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Home;
